<div class="flex justify-content-center align-items-center h-24rem" *ngIf="userLogicService.loading">
    <app-loading></app-loading>
</div>
<router-outlet *ngIf="!userLogicService.loading"></router-outlet>